import * as PAGE from '../../actionTypes/Page/Page';

const initialState = {
  title: '',
  headerZIndexToggle: false,
  sideNavToggle: false,
  navTriggerFocus: false,
  reportLink: {
    link: '',
    name: '',
    hideDownload: true,
    filterByCohort: false,
    passByUD: false,
    saved: false,
    cohortObj: {},
  },
  reportMenus: {
    clientId: null,
    dashboard: {
      reportURL: '',
    },
    reportMenus: [],
  },
  reportTicket: ''
};

export default function pageConfigReducer(state = initialState, action) {
  switch (action.type) {
    case PAGE.PAGE_RESET:
      return { ...state, ...initialState };
    case PAGE.TITLE:
      return {
        ...state,
        title: action.payload,
      };
    case PAGE.HEADER_Z_INDEX:
      return { ...state, headerZIndexToggle: action.headerZIndexToggle };
    case PAGE.NAV_TOGGLE:
      return { ...state, sideNavToggle: action.sideNavToggle };
    case PAGE.NAV_TRIGGER_FOCUS:
      return { ...state, navTriggerFocus: !state.navTriggerFocus };
    case PAGE.REPORT_LINK:
      return { ...state, reportLink: action.reportLink };
    case PAGE.REPORT_MENU:
      return { ...state, reportMenus: { ...state.reportMenus, ...action.reportMenus, } };
    case PAGE.REPORT_MENU_RESET:
      return { ...state, reportMenus: { ...initialState.reportMenus, } };
    case PAGE.REPORT_TICKET:
      return { ...state, reportTicket: action.reportTicket.ticket };
    default:
      return state;
  }
}
